import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button } from "@chakra-ui/react";
import { Form, Popover, PopoverProps, Tooltip } from "antd";
import { ButtonSolid } from "component/button";
import NumberInputFormat from "component/NumberInputFormat";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { formatNumber, unFormat } from "utils/formats";
import Decimal from 'decimal.js';
import {TUsage} from ".."

const MSG_LESS_THAN_ZERO = "数量には0以上の数値を入力してください。";
const MSG_GREATER_THAN_STOCK =
  "在庫数がマイナスになります。再度ご確認ください。";

interface IProps extends PopoverProps {
  equipment_services: any;
  record: any;
  isAllowUpdate: boolean;
  rowIndex: number;
  index: number;
  cellValue: any;
  available: number;
  type: TUsage
}

interface IPopupState {
  rowIndex?: number | undefined;
  colIndex?: number | undefined;
  change?: number;
}

const PopoverChangeAmount = (props: IProps) => {
  const {
    isAllowUpdate,
    rowIndex,
    index,
    record,
    cellValue,
    equipment_services,
    available,
    type
  } = props;

  const [popupState, setPopupState] = useState<IPopupState>();
  const [value, setValue] = useState<string>(cellValue || "0");
  const [disables, setDisables] = useState({
    lessThanZero: Number(unFormat(value)) <= 0,
    greaterThanStock: Number(unFormat(value)) >= available,
  });

  const [searchParams] = useSearchParams();
  const form = Form.useFormInstance();
  const month = dayjs(searchParams.get("month") || Date.now());

  const handleOk = () => {
    setPopupState(undefined);
    form.setFieldValue(
      ["equipment_services", rowIndex, "equipment_service_usages", index],
      {
        ...equipment_services[rowIndex]?.equipment_service_usages?.[index],
        change: Number(unFormat(value)),
        date: dayjs(month.date(index + 1)).format("YYYY-MM-DD"),
      }
    );
  };

  const handlePlus = () => {
    let valueAdd = new Decimal(unFormat(value)).add(1).toNumber()
    if(valueAdd > available) valueAdd = available
    setValue(formatNumber(valueAdd));
  };

  const handleSubtract = () => {
    let valueAdd = new Decimal(unFormat(value)).minus(1).toNumber()
    if(valueAdd<0) valueAdd =0
    else if(valueAdd > available) valueAdd = available
    setValue(formatNumber(valueAdd));
  };

  const handleChange = (val: string) => {
    setValue(val);
  };
  const valueNumber = Number(unFormat(value));
  useEffect(() => {
    setDisables({
      greaterThanStock: valueNumber >= available,
      lessThanZero: valueNumber <= 0,
    });
  }, [value, available]);

  const isError = valueNumber < 0 || valueNumber > available;
  return (
    <Popover
      trigger="click"
      onOpenChange={(value) => {
        !value && setPopupState(undefined)
        setValue(cellValue || "0")
      }}
      open={
        isAllowUpdate &&
        popupState?.rowIndex === rowIndex &&
        popupState?.colIndex === index
      }
      overlayInnerStyle={{
        padding: 0,
      }}
      openClassName="border border-[#EA7E2C] text-[#EA7E2C]"
      className="w-full h-[54px] flex items-center justify-center"
      content={
        <div className="pb-3">
          <p className="font-bold whitespace-nowrap mb-2 flex items-center justify-center text-center border-b h-8 px-2">
            {record.service_name}
          </p>
          <div className="px-4">
            <div className="flex justify-center">
              <div
                className={`flex border rounded h-8 items-center  mb-2 w-[146px] ${
                  isError ? "border-red-500" : "border-black"
                }`}
              >
                <Tooltip
                  title={disables.lessThanZero ? MSG_LESS_THAN_ZERO : false}
                >
                  <Button
                    className="!bg-white !min-w-[36px] !h-6 !p-0"
                    onClick={handleSubtract}
                    isDisabled={disables.lessThanZero}
                  >
                    <MinusOutlined />
                  </Button>
                </Tooltip>
                <div
                  className={`border-x flex items-center ${
                    isError ? "border-red-500" : "border-black"
                  }`}
                >
                  <NumberInputFormat
                    maxDecimalDigits={type== "service" ? 1: undefined}
                    type="math"
                    value={value}
                    onChange={handleChange}
                    defaultValue="0"
                    className={`border-none !shadow-none text-center px-1  ${
                      isError ? "text-red-500" : "text-black"
                    }`}
                  />
                </div>
                <Tooltip
                  title={
                    disables.greaterThanStock ? MSG_GREATER_THAN_STOCK : false
                  }
                >
                  <Button
                    className="!bg-white !min-w-[36px] !h-6 !p-0"
                    onClick={handlePlus}
                    isDisabled={disables.greaterThanStock}
                  >
                    <PlusOutlined />
                  </Button>
                </Tooltip>
              </div>
            </div>
            <div className="flex justify-end">
              <ButtonSolid isDisabled={isError} onClick={handleOk} className="!h-7">
                確認
              </ButtonSolid>
            </div>
          </div>
        </div>
      }
    >
      <div
        className="cursor-pointer"
        onClick={(e) => {
          setPopupState({
            rowIndex: rowIndex,
            colIndex: index,
            change: 1,
          });
        }}
      >
        {cellValue || <br />}
      </div>
    </Popover>
  );
};

export default PopoverChangeAmount;
